var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosereact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29924 4L4 5.29924L10.7008 12L4 18.7008L5.29924 20L12 13.2992L18.7008 20L20 18.7008L13.2992 12L20 5.29924L18.7008 4L12 10.7008L5.29924 4Z",
    fill: "currentColor"
  })));
}
export default SvgClosereact;